import React from 'react';

import { publicPath } from '~/utils/path';

import { Flex } from '../../../blocks/Flex';
import { Overlay } from '../Overlay';

type Props = {
  open: boolean;
  inside?: boolean;
  transparent?: boolean;
  logoSize?: 'half' | 'full';
};

export const Loader = (props: Props) => {
  const logoSrc = publicPath('/loader_circle_white.svg');
  const width = props.logoSize === 'half' ? 80 : 160;

  return (
    <Overlay open={props.open} inside={props.inside} transparent={false}>
      <Flex height="100%" flexDirection="column" alignItems="center" justifyContent="center">
        <img src={logoSrc} width={width} height="auto" />
      </Flex>
    </Overlay>
  );
};
